import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RulesPage, TableRules, SKUPage, SKUTablePage, LegalsTablePage, LegalPage, TableReports, DashboardPage, ErrorPage, TemplatePage, CombosPage, TablePage, DetailSku, CraftPage, DetailTemplate, DetailLegals, SettingsPage, MyCanvasPage, CanvasEditorPage } from '../pages';
import RootLayout from '../components/RootLayout';
import HeaderOnlyLayout from '../components/HeaderOnlyLayout';
import AuthCallback from '../features/sso-auth/components/AuthCallback';
import ProtectedRoute from '../features/sso-auth/components/ProtectedRoute';
import LoginPage from '../features/sso-auth/components/LoginPage';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/callback',
    element: <AuthCallback />,
  },
  {
    element: <ProtectedRoute><RootLayout /></ProtectedRoute>,
    errorElement: <ErrorPage />,
    children: [
      // {
      //   path: '/',
      //   element: <HomePage />,
      // },
      {
        path: '/',
        element: <DashboardPage />,
      },
      {
        path: '/templates',
        element: <TemplatePage />,
      },
      {
        path: '/templates/table',
        element: <TablePage />,
      },
      {
        path: '/templates/:id',
        element: <DetailTemplate />,
      },
      {
        path: '/skus',
        element: <SKUPage />,
      },
      {
        path: '/skus/table',
        element: <SKUTablePage />,
      },
      {
        path: '/skus/:id',
        element: <DetailSku />,
      },
      {
        path: '/manualidades',
        element: <CraftPage />,
      },
      {
        path: '/rules',
        element: <RulesPage />,
      },
      {
        path: '/rules/table',
        element: <TableRules />,
      },
      {
        path: '/combos/table/:id?/:type?',
        element: <CombosPage />,
      },
      {
        path: '/legals',
        element: <LegalPage />,
      },
      {
        path: '/legals/:id',
        element: <DetailLegals />,
      },
      {
        path: '/legals/table',
        element: <LegalsTablePage />,
      },
      {
        path: '/canvas',
        element: <MyCanvasPage />,
      },
      {
        // Old editor url, from before canvases were saved: there's nothing to open there.
        path: '/canvas/create',
        element: <Navigate to="/canvas" replace />,
      },
      {
        path: '/errors',
        element: <TableReports />,
      },
      {
        path: '/settings',
        element: <SettingsPage />,
      },
      {
        path: '*',
        element: <ErrorPage />,
      }
    ]
  },
  {
    element: <ProtectedRoute><HeaderOnlyLayout /></ProtectedRoute>,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/canvas/:id',
        element: <CanvasEditorPage />,
      },
    ]
  }
]);

export default router;
